import { ErrorHandler, Injectable } from "@angular/core";

/** Regex para capturar mensagens de erro ORA- do Oracle */
const ORA_ERRO_REGEX = /ORA-\d{5}: ([^\]\n]+)/;

/** Mapeamento de mensagens de erro do backend para mensagens amigáveis */
const MENSAGENS_ERRO: Record<string, string> = {
  'ORA-12899': 'Um dos campos ultrapassou o limite de caracteres permitido. Verifique os dados informados.',
  'ORA-00001': 'Este registro já existe no sistema.',
  'ORA-02291': 'Registro vinculado não encontrado. Verifique os dados.',
  'ORA-01400': 'Um campo obrigatório não foi preenchido.',
  'ORA-01401': 'O valor informado é muito longo para um dos campos.',
};

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
    handleError(error: any): void {
        CustomErrorHandler.handleError(error);
    }

    static handleError(error: unknown): void {
        console.error(error); // NOSONAR: error handler intencional
    }

    /**
     * Extrai uma mensagem amigável a partir de um erro HTTP do backend.
     * Se o erro for uma exception SQL (ORA-*), retorna uma mensagem genérica.
     * Caso contrário, retorna a mensagem original do backend ou um fallback.
     */
    static extrairMensagem(erro: any, fallback = 'Ocorreu um erro inesperado. Tente novamente mais tarde.'): string {
      const mensagemOriginal = erro?.error?.mensagem ?? erro?.mensagem ?? '';

      if (!mensagemOriginal) return fallback;

      for (const [codigo, msg] of Object.entries(MENSAGENS_ERRO)) {
        if (mensagemOriginal.includes(codigo)) return msg;
      }

      if (/ORA-\d{5}/.test(mensagemOriginal)) {
        return 'Não foi possível concluir a solicitação. Por favor, confira as informações preenchidas e tente novamente.';
      }

      if (mensagemOriginal.length < 200 && !mensagemOriginal.includes('ORA-')) {
        return mensagemOriginal;
      }

      return fallback;
    }
}
